var _defs, _rect, _rect2, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenspace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "0e6a70a4c8"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "8dd17c885f"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "08793a6b23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 72.832031 58.625 L 343.582031 58.625 L 343.582031 342.121094 L 72.832031 342.121094 Z M 72.832031 58.625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e36e1ed478"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91.582031 58.625 L 324.585938 58.625 C 329.558594 58.625 334.328125 60.597656 337.84375 64.117188 C 341.359375 67.632812 343.335938 72.402344 343.335938 77.375 L 343.335938 323.289062 C 343.335938 328.261719 341.359375 333.03125 337.84375 336.546875 C 334.328125 340.0625 329.558594 342.039062 324.585938 342.039062 L 91.582031 342.039062 C 86.609375 342.039062 81.839844 340.0625 78.324219 336.546875 C 74.808594 333.03125 72.832031 328.261719 72.832031 323.289062 L 72.832031 77.375 C 72.832031 72.402344 74.808594 67.632812 78.324219 64.117188 C 81.839844 60.597656 86.609375 58.625 91.582031 58.625 Z M 91.582031 58.625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce9ea2e2fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.246094 37.5 L 322.753906 37.5 L 322.753906 320.691406 L 52.246094 320.691406 Z M 52.246094 37.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b80b775ded"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70.996094 37.5 L 304.003906 37.5 C 308.976562 37.5 313.746094 39.476562 317.261719 42.992188 C 320.78125 46.507812 322.753906 51.277344 322.753906 56.25 L 322.753906 302.171875 C 322.753906 307.144531 320.78125 311.914062 317.261719 315.429688 C 313.746094 318.945312 308.976562 320.921875 304.003906 320.921875 L 70.996094 320.921875 C 66.023438 320.921875 61.253906 318.945312 57.738281 315.429688 C 54.21875 311.914062 52.246094 307.144531 52.246094 302.171875 L 52.246094 56.25 C 52.246094 51.277344 54.21875 46.507812 57.738281 42.992188 C 61.253906 39.476562 66.023438 37.5 70.996094 37.5 Z M 70.996094 37.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -3.051026,
    gradientTransform: "matrix(1.056681, 0, 0, 1.056681, 52.244823, 37.491609)",
    y1: 3.058974,
    x2: 258.949457,
    gradientUnits: "userSpaceOnUse",
    y2: 265.058467,
    id: "74b34929a3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.599548%, 41.600037%, 3.900146%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.717041%, 41.729736%, 3.994751%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.953552%, 41.989136%, 4.18396%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.188538%, 42.250061%, 4.373169%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.425049%, 42.50946%, 4.563904%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.660034%, 42.770386%, 4.753113%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.896545%, 43.029785%, 4.942322%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.131531%, 43.289185%, 5.133057%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.368042%, 43.55011%, 5.322266%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.604553%, 43.809509%, 5.513%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.839539%, 44.070435%, 5.702209%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.07605%, 44.329834%, 5.891418%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.311035%, 44.589233%, 6.082153%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.547546%, 44.850159%, 6.271362%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.782532%, 45.109558%, 6.460571%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.019043%, 45.370483%, 6.651306%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.254028%, 45.629883%, 6.840515%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.49054%, 45.890808%, 7.029724%)",
    offset: 0.132813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.727051%, 46.150208%, 7.220459%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.962036%, 46.409607%, 7.409668%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.198547%, 46.670532%, 7.600403%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.433533%, 46.929932%, 7.789612%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.670044%, 47.190857%, 7.978821%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.905029%, 47.450256%, 8.169556%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.141541%, 47.711182%, 8.358765%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.378052%, 47.970581%, 8.547974%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.613037%, 48.22998%, 8.738708%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.849548%, 48.490906%, 8.927917%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.084534%, 48.750305%, 9.117126%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.321045%, 49.01123%, 9.307861%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.55603%, 49.27063%, 9.49707%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.792542%, 49.531555%, 9.687805%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.027527%, 49.790955%, 9.877014%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.264038%, 50.050354%, 10.066223%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.500549%, 50.311279%, 10.256958%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.735535%, 50.570679%, 10.446167%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.972046%, 50.831604%, 10.635376%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.207031%, 51.091003%, 10.826111%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.443542%, 51.351929%, 11.01532%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.678528%, 51.611328%, 11.204529%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.915039%, 51.870728%, 11.395264%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.150024%, 52.131653%, 11.584473%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.386536%, 52.391052%, 11.775208%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.623047%, 52.651978%, 11.964417%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.858032%, 52.911377%, 12.153625%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.094543%, 53.170776%, 12.34436%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.329529%, 53.431702%, 12.533569%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.56604%, 53.691101%, 12.722778%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.801025%, 53.952026%, 12.913513%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.037537%, 54.211426%, 13.102722%)",
    offset: 0.382813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.274048%, 54.472351%, 13.291931%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.509033%, 54.73175%, 13.482666%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.745544%, 54.99115%, 13.671875%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.98053%, 55.252075%, 13.86261%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.217041%, 55.511475%, 14.051819%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.452026%, 55.7724%, 14.241028%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.688538%, 56.031799%, 14.431763%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.923523%, 56.292725%, 14.620972%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.160034%, 56.552124%, 14.810181%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.396545%, 56.811523%, 15.000916%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.631531%, 57.072449%, 15.190125%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.868042%, 57.331848%, 15.379333%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.103027%, 57.592773%, 15.570068%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.339539%, 57.852173%, 15.759277%)",
    offset: 0.488551
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.457031%, 57.983398%, 15.855408%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.574524%, 58.113098%, 15.950012%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.811035%, 58.372498%, 16.139221%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.046021%, 58.631897%, 16.32843%)",
    offset: 0.511449
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.165039%, 58.763123%, 16.424561%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.282532%, 58.892822%, 16.519165%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.519043%, 59.152222%, 16.708374%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.754028%, 59.413147%, 16.897583%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.99054%, 59.672546%, 17.088318%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.225525%, 59.933472%, 17.277527%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.462036%, 60.192871%, 17.466736%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.697021%, 60.452271%, 17.657471%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.933533%, 60.713196%, 17.84668%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.168518%, 60.972595%, 18.037415%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.405029%, 61.233521%, 18.226624%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.641541%, 61.49292%, 18.415833%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.876526%, 61.753845%, 18.606567%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.113037%, 62.013245%, 18.795776%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.348022%, 62.272644%, 18.984985%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.584534%, 62.533569%, 19.17572%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.819519%, 62.792969%, 19.364929%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.05603%, 63.053894%, 19.554138%)",
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.292542%, 63.313293%, 19.744873%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.527527%, 63.572693%, 19.934082%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.764038%, 63.833618%, 20.124817%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.999023%, 64.093018%, 20.314026%)",
    offset: 0.679687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.235535%, 64.353943%, 20.503235%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.47052%, 64.613342%, 20.69397%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.707031%, 64.874268%, 20.883179%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.942017%, 65.133667%, 21.072388%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.178528%, 65.393066%, 21.263123%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.415039%, 65.653992%, 21.452332%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.650024%, 65.913391%, 21.641541%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.886536%, 66.174316%, 21.832275%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.121521%, 66.433716%, 22.021484%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.358032%, 66.694641%, 22.212219%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.593018%, 66.954041%, 22.401428%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.829529%, 67.21344%, 22.590637%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.064514%, 67.474365%, 22.781372%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.301025%, 67.733765%, 22.970581%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.537537%, 67.99469%, 23.15979%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.772522%, 68.254089%, 23.350525%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.009033%, 68.515015%, 23.539734%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.244019%, 68.774414%, 23.730469%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.48053%, 69.033813%, 23.919678%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.715515%, 69.294739%, 24.108887%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.952026%, 69.554138%, 24.299622%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.188538%, 69.815063%, 24.488831%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.423523%, 70.074463%, 24.67804%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.660034%, 70.335388%, 24.868774%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.89502%, 70.594788%, 25.057983%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.131531%, 70.854187%, 25.247192%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.366516%, 71.115112%, 25.437927%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.603027%, 71.374512%, 25.627136%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.838013%, 71.635437%, 25.817871%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.074524%, 71.894836%, 26.00708%)",
    offset: 0.914063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.311035%, 72.155762%, 26.196289%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.546021%, 72.415161%, 26.387024%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.782532%, 72.674561%, 26.576233%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.017517%, 72.935486%, 26.765442%)",
    offset: 0.945313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.254028%, 73.194885%, 26.956177%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.489014%, 73.455811%, 27.145386%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.725525%, 73.71521%, 27.334595%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.96051%, 73.974609%, 27.52533%)",
    offset: 0.976563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.197021%, 74.235535%, 27.714539%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.433533%, 74.494934%, 27.905273%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.668518%, 74.755859%, 28.094482%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d9b9eb5351"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 108.035156 119.449219 L 351.785156 119.449219 L 351.785156 363 L 108.035156 363 Z M 108.035156 119.449219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 500,
    xlinkHref: "data:image/png;base64,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",
    id: "8503b37cc4",
    height: 500,
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "5d0d1c860a"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#0e6a70a4c8)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8dd17c885f)",
    transform: "matrix(0.4875, 0, 0, 0.4875, 108.033917, 119.448626)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 500,
    xlinkHref: "data:image/png;base64,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",
    height: 500,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 500,
    xlinkHref: "data:image/png;base64,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",
    id: "40da401e03",
    height: 500,
    preserveAspectRatio: "xMidYMid meet"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#08793a6b23)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e36e1ed478)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 72.831739, 58.623901)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 25.000391 0.0014654 L 335.672287 0.0014654 C 342.302496 0.0014654 348.661871 2.631674 353.349371 7.324383 C 358.036872 12.011883 360.672288 18.371258 360.672288 25.001467 L 360.672288 352.886905 C 360.672288 359.517114 358.036872 365.876489 353.349371 370.56399 C 348.661871 375.25149 342.302496 377.886907 335.672287 377.886907 L 25.000391 377.886907 C 18.370183 377.886907 12.010807 375.25149 7.323307 370.56399 C 2.635807 365.876489 0.000389777 359.517114 0.000389777 352.886905 L 0.000389777 25.001467 C 0.000389777 18.371258 2.635807 12.011883 7.323307 7.324383 C 12.010807 2.631674 18.370183 0.0014654 25.000391 0.0014654 Z M 25.000391 0.0014654 ",
    stroke: "#96bf48",
    strokeWidth: 20,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce9ea2e2fd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b80b775ded)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#74b34929a3)",
    d: "M 52.246094 37.5 L 52.246094 320.691406 L 322.753906 320.691406 L 322.753906 37.5 Z M 52.246094 37.5 ",
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d9b9eb5351)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#5d0d1c860a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4875, 0, 0, 0.4875, 108.033917, 119.448626)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 500,
    xlinkHref: "data:image/png;base64,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",
    height: 500,
    preserveAspectRatio: "xMidYMid meet"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenspace);
export default __webpack_public_path__ + "static/media/penspace.3f4f6b406e820510ef598a0b26cbbc5d.svg";
export { ForwardRef as ReactComponent };